/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_Views_MenuInputs */

const en_cmd_views_menu = /** @type {(inputs: Cmd_Views_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open views`)
};

const de_cmd_views_menu = /** @type {(inputs: Cmd_Views_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansichten öffnen`)
};

/**
* | output |
* | --- |
* | "Open views" |
*
* @param {Cmd_Views_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_views_menu = /** @type {((inputs?: Cmd_Views_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_Views_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_views_menu(inputs)
	return en_cmd_views_menu(inputs)
});